export default __webpack_public_path__ + "static/media/Animations_Bar12.8fd5450e.svg";